<template>
    <div class="food_item_content_media" :data-indicador="indicador" :id="'food_item_content_media_'+indicador">
        <div class="food_gallery_slider" :data-indicador="indicador" :id="'food_gallery_slider'+indicador">
            <ul :data-indicador="indicador" v-if="gallery && gallery.length>0" :id="'food_gallery_slider_list_'+indicador">
                <li v-for="(g, gIdx) in gallery" :key="gIdx" :data-indicador="indicador" :id="'gellery_'+indicador+'_item_'+g.id" :class="['gellery_'+indicador+'_items', (itemId==g.id) ? 'active' : '']" :data-itemg="g.id">
                    <img v-if="g.type_file=='img'" class="food_item_img" :src="urlMedia+'/img/'+g.name_file" alt="" :data-indicador="indicador">
                    <video v-else :src="urlMedia+'/video/'+g.name_file" controls muted loop preload="auto" :poster="urlMedia+'/video/'+g.name_file+'.jpg'" class="food_item_video" :data-indicador="indicador"></video>
                </li>
            </ul>
            <ul v-else>
                <li>
                    <img class="food_item_img" src="@/core/assets/img/add-img-icon.png" alt="add image" :data-indicador="indicador" @click.prevent="$emit('editGallery', {name: 'foodUpload', data: {foodItem, urlMedia}})">
                </li>
            </ul>
        </div>
        <div class="food_item_btns">
            <button class="btn-edit" @click.prevent="$emit('editGallery', {name: 'foodUpload', data: {foodItem, urlMedia}})">Edit</button>
        </div>
        <div class="food_item_nav" v-if="gallery && gallery.length>0">
            <ul :data-indicador="indicador" v-if="gallery && gallery.length>0">
                <li v-for="(g, gIdx) in gallery" :key="gIdx" >
                    <a href="#" :class="['nav-item', (itemId==g.id) ? 'active' : '']" :id="'nav_item_'+g.id" :data-itemg="g.id" @click.prevent="indicadorSlider(g.id)"></a>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    props: ['foodItem', 'indicador', 'gallery', 'urlMedia'],
    data(){
        return {
            itemId: null,
        };
    },
    watch: {
        gallery(){
            let t = this;
            t.itemId = (t.gallery && t.gallery.length>0) ? t.gallery[0].id : 0;
        }
    },
    mounted(){
        let t = this;
        t.itemId = (t.gallery && t.gallery.length>0) ? t.gallery[0].id : 0;
    },
    methods: {
        indicadorSlider(ids){
            console.log('indicadorSlider', ids);
            this.itemId = ids;
            this.$emit('clickNav', {SliderId: ids, indicador: this.indicador});
        },
    }
}
</script>
<style lang="scss" scoped>
.food_item_nav{position:relative;left:0;right:0;z-index:1;display:flex;align-items:center;justify-content:center;margin: -15px 0 4px 0;}
.food_item_nav ul{margin:0;padding:0;display:flex;list-style:none}
.food_item_nav ul li{flex:none;margin:0 5px}
.food_item_nav ul li a{display:block;padding:5px;background:#dbe0e6;border-radius:50%;opacity:.5}
.food_item_nav ul li a:hover, .food_item_nav ul li a.active{cursor:pointer;opacity:1}
</style>
